var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "close-tag",
  "use": "close-tag-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"close-tag\"><g fill=\"#000\" fill-rule=\"evenodd\"><path d=\"m1.98.565 25.455 25.456-1.414 1.414L.565 1.979z\" /><path d=\"M26.02.565.566 26.021l1.414 1.414L27.435 1.979z\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol